// extracted by mini-css-extract-plugin
export default {"splash":"SplashScreen_splash__rzaj+","logo":"SplashScreen_logo__DB4iw","splash-enter":"SplashScreen_splash-enter__rZEiI","splash-breathe":"SplashScreen_splash-breathe__LSN1G"};